import { useFormikContext } from "formik";
import { styled } from "@mui/material";
import DurationInput from "../components/duration-input/DurationInput.jsx";
import { useCallback } from "react";
import { useFormInputHelpers } from "./useFormInputHelpers.js";

const DurationInputStyled = styled(DurationInput)({
  fontSize: "14px",
});

const FormDurationInput = ({
  name,
  onChange,
  shouldHaveErrorBehaviorAfterSubmit,
  helperText,
  className,
  ...props
}) => {
  const { values, setFieldValue, setFieldTouched } = useFormikContext();

  const handleChange = useCallback(
    (duration) => {
      if (typeof onChange === "function") {
        onChange(duration);
      } else {
        setFieldValue(name, duration).then(() => {
          setFieldTouched(name, true);
        });
      }
    },
    [name, onChange, setFieldTouched, setFieldValue]
  );

  const { shouldDisplayError, finalHelperText } = useFormInputHelpers({
    name,
    shouldHaveErrorBehaviorAfterSubmit,
    helperText,
  });

  return (
    <DurationInputStyled
      name={name}
      value={values[name]}
      helperText={finalHelperText}
      isError={shouldDisplayError}
      onChange={handleChange}
      className={className}
      {...props}
    />
  );
};
export default FormDurationInput;
